export default __webpack_public_path__ + "static/max-callout-95843497527de84ad963db079b2c9272.jpg";